<template>
  <footer class="footer">
    <div class="footer__container">
      <div class="footer__inner">
        <div class="footer__cop">
          <VIcon
            class="footer__el cursor"
            width="122"
            height="34"
            icon-name="Logo"
            @click="gotender-demo" />
          <!--          <button class="btn btn-link footer__el">Карта сайта</button>-->
          <p>© ООО «Тендер», 2022-2025</p>
        </div>

        <div class="footer__contact">
          <div class="footer__el">Контактная информация</div>
          <!--          <button class="btn btn-link btn-link-classic footer__el">Контактная информация</button>-->
          <div class="footer__email cur footer__el">
            Электронная почта:
            <a href="mailto: info@tender-demo.ru" class="btn btn-link btn-link-classic">info@tender-demo.ru</a>
          </div>
          <div class="contact">
            <div class="contact__link">
              <button class="btn">
                <VIcon width="40" height="40" icon-name="VK" fill="none" @click="goVK" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import VIcon from '@/components/ui/icon/VIcon.vue'
import { goSitno, goVK } from '@/utils/goRoute.js'

export default {
  components: { VIcon },
  setup() {
    return {
      goSitno,
      goVK,
    }
  },
}
</script>
<style scoped>
.cursor {
  cursor: pointer;
}
</style>
